.locationButtonContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
  width: 100%;
  cursor: pointer;
  color: var(--bloom-colors-header-contrast-text-label);
}
